import './index.css'
const MainSiteLoader = () => {
    return (
        <div className='bg-[#003366]/10 flex h-screen w-full items-center justify-center flex-col relative'>
            <div className="loadingspinner z-10"> 
                <div id="square1"></div>
                <div id="square2"></div>
                <div id="square3"></div>
                <div id="square4"></div>
                <div id="square5"></div>
            </div>
        </div>

    )
}

export default MainSiteLoader